module.exports = __webpack_public_path__ + "static/img/omantel.fe88314f.png";